/**
 * Base URL for platform services (store, importer, obp_ai) behind the API gateway.
 *
 * Scraper UI is served on collector.brandtrax.* with relative paths to the scraper
 * backend on the same host. Store/importer must call api.brandtrax.* instead.
 */
export function resolvePlatformApiBaseUrl(): string {
  const fromEnv = (import.meta.env.VITE_BASE_URL as string | undefined)?.trim();
  if (fromEnv) {
    return fromEnv;
  }

  if (typeof window !== 'undefined') {
    const { hostname, protocol } = window.location;
    if (hostname.startsWith('collector.')) {
      return `${protocol}//${hostname.replace(/^collector\./, 'api.')}`;
    }
  }

  // Builds that set VITE_API_BASE_URL to the API gateway (no separate VITE_BASE_URL).
  const apiBase = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();
  if (apiBase && apiBase.includes('api.brandtrax.')) {
    return apiBase;
  }

  return '';
}

/** True when store/importer calls go to a different origin (e.g. collector.* → api.*). */
export function isPlatformApiCrossOrigin(): boolean {
  const base = resolvePlatformApiBaseUrl();
  if (!base || typeof window === 'undefined') {
    return false;
  }
  try {
    if (base.startsWith('/') || base.startsWith('.')) {
      return false;
    }
    const resolved = new URL(base, window.location.origin);
    return resolved.origin !== window.location.origin;
  } catch {
    return false;
  }
}
